import { date, ref } from "yup";

export default ({ intl, hasAdminPrivileges }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const notADate = intl.formatMessage({ id: "app.form.notadate" });
  const startDateNotAfterEndDate = intl.formatMessage({ id: "app.form.startDateNotAfterEndDate" });

  return hasAdminPrivileges
    ? {
        startDate: date()
          .required(requiredText)
          .typeError(notADate)
          .when("endDate", {
            is: endDate => endDate !== null,
            then: strDate => strDate.max(ref("endDate"), startDateNotAfterEndDate),
          }),
      }
    : {};
};
